import useStyleUtils from "../../../utilities/styles";
import IPasswordFormProps from "../IPasswordFormProps";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-grid-system";
import TextField from "../../../components/formFields/textField/TextField";
import PasswordField from "../fields/password-field/PasswordField";
import TextArea from "../../../components/formFields/textArea/TextArea";
import PersonalPasswordField from "../fields/personal-pw-field/PersonalPasswordField";
import { NIL as empty } from 'uuid';

export default function DetailsTab(props: IPasswordFormProps) {
    const { t } = useTranslation();

    const style = useStyleUtils();

    return (
        <Row>
            <Col>
                <Row>
                    <Col className={style.mb3}>
                        <TextField required
                            type='text'
                            label={t("passwords.form.fields.username.label")}
                            value={props.data.username}
                            onChange={(value) => props.onChange('username', value)}
                            placeholder={t("passwords.form.fields.username.placeholder")}
                            />
                    </Col>
                </Row>

                <Row>
                    <Col className={style.mb3}>
                        <PasswordField
                            password={props.data.password}
                            onChange={props.onChange}
                            />
                    </Col>
                </Row>

                <Row>
                    <Col className={style.mb3}>
                        <TextField required
                            type='text'
                            label={t("passwords.form.fields.label.label")}
                            value={props.data.label}
                            onChange={(value) => props.onChange('label', value)}
                            placeholder={t("passwords.form.fields.label.placeholder")}
                            />
                    </Col>
                </Row>

                <Row>
                    <Col className={style.mb3}>
                        <TextArea
                            label={t("passwords.form.fields.notes.label")}
                            value={props.data.notes}
                            onChange={(value) => props.onChange('notes', value)}
                            placeholder={t("passwords.form.fields.notes.placeholder")}
                            />
                    </Col>
                </Row>

                {
                    !props.shouldHidePersonalPassword &&
                    props.data.id === empty &&
                    <PersonalPasswordField
                        isPersonal={props.data.isPersonal}
                        onChange={(checked) => props.onChange('isPersonal', checked)}
                        />
                }
            </Col>
        </Row>
    );
}